// extracted by mini-css-extract-plugin
export default {"default":"Link_default__YcBZG","primaryColor":"Link_primaryColor__3y+c5","underscored":"Link_underscored__2zosy","noneDecoration":"Link_noneDecoration__VQifH"};